import { Icons } from '@commenda/kakashi';
import { useEffect, useState } from 'react';
import { VerticalDrawerNew } from '../components';
import { TWorkflowProcessDrawerProps } from './types';
import { WorkflowProcessParentSteps } from './WorkflowProcessParentSteps';

const WorkflowProcessDrawer = ({
  onClose,
  isShown,
  steps,
  activeParentStepId,
  setActiveParentStepId,
  header,
  hideHeader = false,
  renderButton,
  bannerComp,
}: TWorkflowProcessDrawerProps) => {
  const [activeParentStep, setActiveParentStep] = useState(
    steps.find((step) => step.key === activeParentStepId) || steps[0]
  );

  useEffect(() => {
    setActiveParentStep(
      steps.find((step) => step.key === activeParentStepId) || steps[0]
    );
  }, [activeParentStepId, steps]);

  return (
    <VerticalDrawerNew isOpen={isShown} close={onClose}>
      <div className="flex flex-col">
        <div className="py-3 px-6 flex justify-between items-center border-b border-b-border-primary">
          {header}

          <div
            className="h-9 w-9 flex justify-center items-center cursor-pointer"
            onClick={onClose}
          >
            <Icons.X className="h-5 w-5 text-fg-quinary hover:text-fg-quinary-hover" />
          </div>
        </div>
        {bannerComp}
        <div className="flex">
          <WorkflowProcessParentSteps
            steps={steps}
            hideHeader={hideHeader}
            activeStep={activeParentStep}
            setActiveStep={(step) => {
              setActiveParentStep(step);
              setActiveParentStepId(step.key);
            }}
            renderButton={renderButton}
          />
          <div className="flex-1 h-[calc(100vh-64px)] overflow-y-auto py-6 px-10 bg-bg-primary flex flex-col gap-16">
            {activeParentStep.children}
          </div>
        </div>
      </div>
    </VerticalDrawerNew>
  );
};

export { WorkflowProcessDrawer };
